import React from 'react';
import { usesNewMeters } from '../../utils/meterCutover';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Svg,
  Path,
} from '@react-pdf/renderer';

// Create styles for Standard Monthly Inspection Report PDF
const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 10,
    lineHeight: 1.3,
    position: 'relative',
  },

  // Cover Page Styles
  coverPage: {
    position: 'relative',
    padding: 0,
    margin: 0,
  },
  coverBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  coverPageInnerView: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  coverLogo: {
    position: 'absolute',
    top: 35,
    right: 45,
    width: 150,
  },
  coverTitleBox: {
    position: 'absolute',
    top: 180,
    left: 30,
    backgroundColor: '#1E3A5F',
    padding: 20,
    paddingRight: 40,
    maxWidth: 280,
  },
  coverTitle: {
    fontSize: 26,
    fontWeight: 'bold',
    color: 'white',
    lineHeight: 1.2,
  },
  coverFooter: {
    position: 'absolute',
    bottom: 50,
    right: 30,
    textAlign: 'right',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 4,
  },
  coverFooterWebsite: {
    color: 'white',
    fontSize: 14,
    marginBottom: 5,
    textAlign: 'right',
  },
  coverFooterPhone: {
    color: 'white',
    fontSize: 22,
    textAlign: 'right',
    fontWeight: 'bold',
  },

  // Content Page Styles
  contentPage: {
    padding: 30,
    paddingTop: 20,
  },
  logoContainer: {
    alignItems: 'flex-end',
    marginBottom: 15,
  },
  pageLogo: {
    width: 130,
  },
  pageFooter: {
    position: 'absolute',
    bottom: 20,
    right: 30,
    fontSize: 9,
    color: '#666',
  },

  // Introducing Page Styles
  introTitle: {
    fontSize: 42,
    fontWeight: 'bold',
    color: '#1E3A5F',
    marginBottom: 15,
    lineHeight: 1.0,
  },
  introSubtitle: {
    fontSize: 11,
    fontStyle: 'italic',
    color: '#333',
    marginBottom: 8,
    lineHeight: 1.3,
  },
  introText: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 15,
  },
  twoColumnRow: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  serviceBox: {
    flex: 1,
    marginRight: 8,
    border: '1 solid #ccc',
  },
  serviceBoxLast: {
    flex: 1,
    border: '1 solid #ccc',
  },
  serviceBoxHeader: {
    backgroundColor: '#1E3A5F',
    padding: 10,
    paddingVertical: 8,
  },
  serviceBoxHeaderText: {
    color: 'white',
    fontSize: 13,
    fontWeight: 'bold',
  },
  serviceBoxBody: {
    padding: 10,
    backgroundColor: 'white',
    minHeight: 100,
  },
  checkItem: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'center',
  },
  checkBox: {
    width: 16,
    height: 16,
    backgroundColor: '#E8505B',
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkMark: {
    color: 'white',
    fontSize: 11,
  },
  checkText: {
    flex: 1,
    fontSize: 10,
    color: '#333',
  },
  advantagesBox: {
    backgroundColor: '#1E3A5F',
    padding: 15,
    width: '48%',
  },
  advantagesTitle: {
    color: 'white',
    fontSize: 13,
    fontWeight: 'bold',
    marginBottom: 12,
    lineHeight: 1.3,
  },
  advantagesItem: {
    flexDirection: 'row',
    marginBottom: 6,
    alignItems: 'center',
  },
  advantagesCheckBox: {
    width: 16,
    height: 16,
    backgroundColor: '#4ECDC4',
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  advantagesText: {
    color: 'white',
    fontSize: 10,
    flex: 1,
  },
  quoteBox: {
    flex: 1,
    paddingLeft: 15,
    justifyContent: 'center',
  },
  quoteLine: {
    backgroundColor: '#4ECDC4',
    paddingVertical: 3,
    paddingHorizontal: 5,
    // marginBottom: 2,
    alignSelf: 'flex-start',
  },
  quoteText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'white',
  },

  // Services Page Styles
  servicesHeader: {
    backgroundColor: '#1E3A5F',
    padding: 30,
    marginBottom: 20,
    marginHorizontal: -30,
    marginTop: -20,
  },
  servicesTitle: {
    color: 'white',
    fontSize: 32,
    fontWeight: 'bold',
    lineHeight: 1.2,
  },
  servicesSubtitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 15,
  },
  servicesGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  serviceCard: {
    width: '48%',
    backgroundColor: '#1E3A5F',
    padding: 12,
    marginBottom: 10,
    marginRight: '2%',
    flexDirection: 'row',
  },
  serviceCardOdd: {
    width: '48%',
    backgroundColor: '#1E3A5F',
    padding: 12,
    marginBottom: 10,
    flexDirection: 'row',
  },
  serviceIcon: {
    width: 35,
    height: 35,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  serviceIconImage: {
    width: 35,
    height: 35,
    objectFit: 'contain',
  },
  serviceCardContent: {
    flex: 1,
  },
  serviceCardTitle: {
    color: 'white',
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 3,
  },
  serviceCardText: {
    color: 'white',
    fontSize: 8,
    lineHeight: 1.3,
  },

  // Report Page Styles
  reportTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1E3A5F',
    marginBottom: 15,
  },
  photoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 15,
  },
  photoBox: {
    width: '49%',
    marginRight: '1%',
    marginBottom: 10,
  },
  photoBoxRight: {
    width: '49%',
    marginLeft: '1%',
    marginBottom: 10,
  },
  photoImage: {
    width: '100%',
    height: 150,
    backgroundColor: '#f0f0f0',
    objectFit: 'cover',
  },
  photoLabel: {
    backgroundColor: '#1E3A5F',
    padding: 8,
  },
  photoLabelText: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
  noPhotoBox: {
    width: '100%',
    height: 150,
    backgroundColor: '#f0f0f0',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noPhotoText: {
    color: '#999',
    fontSize: 10,
  },

  // Info Tables
  infoTable: {
    marginBottom: 10,
    border: '1 solid #1E3A5F',
  },
  infoRow: {
    flexDirection: 'row',
    borderBottom: '1 solid #1E3A5F',
  },
  infoRowLast: {
    flexDirection: 'row',
  },
  infoLabel: {
    width: '25%',
    backgroundColor: '#1E3A5F',
    color: 'white',
    padding: 8,
    fontSize: 10,
    fontWeight: 'bold',
  },
  infoValue: {
    width: '75%',
    padding: 8,
    fontSize: 10,
    backgroundColor: 'white',
  },
  infoTableTwoCol: {
    marginBottom: 10,
    border: '1 solid #1E3A5F',
  },
  infoLabelSmall: {
    width: '25%',
    backgroundColor: '#1E3A5F',
    color: 'white',
    padding: 8,
    fontSize: 10,
    fontWeight: 'bold',
  },
  infoValueSmall: {
    width: '25%',
    padding: 8,
    fontSize: 10,
    backgroundColor: 'white',
    borderRight: '1 solid #1E3A5F',
  },
  infoValueSmallLast: {
    width: '25%',
    padding: 8,
    fontSize: 10,
    backgroundColor: 'white',
  },

  // Meter Table
  meterTable: {
    marginBottom: 20,
    border: '1 solid #1E3A5F',
  },
  meterRow: {
    flexDirection: 'row',
    borderBottom: '1 solid #1E3A5F',
  },
  meterRowLast: {
    flexDirection: 'row',
  },
  meterLabel: {
    width: '25%',
    backgroundColor: '#1E3A5F',
    color: 'white',
    padding: 8,
    fontSize: 9,
    fontWeight: 'bold',
  },
  meterValue: {
    width: '25%',
    padding: 8,
    fontSize: 9,
    backgroundColor: 'white',
    borderRight: '1 solid #1E3A5F',
  },
  meterSerialLabel: {
    width: '25%',
    backgroundColor: '#1E3A5F',
    color: 'white',
    padding: 8,
    fontSize: 9,
    fontWeight: 'bold',
  },
  meterSerialValue: {
    width: '25%',
    padding: 8,
    fontSize: 9,
    backgroundColor: 'white',
  },

  // Checklist Styles
  checklistTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1E3A5F',
    marginBottom: 5,
  },
  checklistSection: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1E3A5F',
    marginBottom: 10,
  },
  checklistTable: {
    border: '1 solid #333',
    marginBottom: 20,
  },
  checklistHeader: {
    flexDirection: 'row',
    borderBottom: '1 solid #333',
  },
  checklistHeaderName: {
    width: '25%',
    padding: 8,
    fontSize: 10,
    fontWeight: 'bold',
    borderRight: '1 solid #333',
  },
  checklistHeaderCondition: {
    width: '20%',
    padding: 8,
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
    borderRight: '1 solid #333',
  },
  checklistHeaderNotes: {
    width: '55%',
    padding: 8,
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  conditionSubHeader: {
    flexDirection: 'row',
  },
  conditionGood: {
    width: '50%',
    padding: 3,
    fontSize: 9,
    textAlign: 'center',
    borderRight: '1 solid #333',
  },
  conditionNotGood: {
    width: '50%',
    padding: 3,
    fontSize: 9,
    textAlign: 'center',
  },
  checklistRow: {
    flexDirection: 'row',
    borderBottom: '1 solid #333',
  },
  checklistRowLast: {
    flexDirection: 'row',
  },
  checklistName: {
    width: '25%',
    padding: 6,
    fontSize: 9,
    borderRight: '1 solid #333',
  },
  checklistConditionCell: {
    width: '20%',
    flexDirection: 'row',
    borderRight: '1 solid #333',
  },
  checklistGood: {
    width: '50%',
    padding: 6,
    borderRight: '1 solid #333',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checklistNotGood: {
    width: '50%',
    padding: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checklistNotes: {
    width: '55%',
    padding: 6,
    fontSize: 9,
  },

  // Conclusion styles
  ticketNote: {
    fontSize: 11,
    fontStyle: 'italic',
    fontWeight: 'bold',
    marginBottom: 15,
    marginTop: 10,
  },
  conclusionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  conclusionText: {
    fontSize: 10,
    marginBottom: 10,
    lineHeight: 1.4,
  },
  signOff: {
    fontSize: 10,
    marginBottom: 20,
  },
  signatureImage: {
    width: 150,
    height: 60,
    marginBottom: 20,
  },
  inspectorName: {
    fontSize: 10,
    fontWeight: 'bold',
  },

  // Footer Page Styles
  footerContent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 150,
  },
  footerCompanyName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1E3A5F',
    marginBottom: 15,
    textAlign: 'center',
  },
  footerAddress: {
    fontSize: 11,
    marginBottom: 3,
    textAlign: 'center',
    color: '#333',
  },
  footerEmail: {
    fontSize: 11,
    marginTop: 15,
    textAlign: 'center',
  },
  footerEmailLabel: {
    color: '#1E3A5F',
    fontWeight: 'bold',
  },
  footerWebsite: {
    fontSize: 11,
    color: '#1E3A5F',
    fontWeight: 'bold',
    marginTop: 5,
    textAlign: 'center',
  },
  footerLogosContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 50,
    width: '100%',
    gap: 8,
  },
  footerLogoItem: {
    width: 42,
    height: 28,
    objectFit: 'contain',
  },
});

// Month names
const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

// Checklist definitions
const externalItems = [
  'Front Door', 'Back Door', 'Other Exit Door', 'External Walls', 'Windows',
  'Garage/Shed', 'Lawn', 'Bin(s)', 'Exits Clear', 'Other'
];

const communalItems = [
  'Door', 'Wall', 'Ceiling', 'Window(s)', 'Floor',
  'Light(s)', 'Fire Extinguisher(s)', 'Plug socket(s)', 'Other'
];

const kitchenItems = [
  'Door(s)', 'Wall', 'Ceiling', 'Window(s)', 'Floor', 'Light(s)',
  'Washing Machine', 'Hot plate', 'Microwave', 'Bin(s)', 'Sink',
  'Plug socket(s)', 'Fire extinguisher(s)', 'Fire blanket', 'Other'
];

const livingSpaceItems = [
  'Door', 'Wall', 'Ceiling', 'Window(s)', 'Floor', 'Light(s)',
  'Plug socket(s)', 'Fire extinguisher(s)', 'Fire blanket', 'Other'
];

const bathroomItems = [
  'Door', 'Wall', 'Ceiling', 'Window', 'Floor', 'Light',
  'Plug socket(s)', 'Water', 'Shower/cubicle', 'Bath', 'Sink', 'Extractor fan', 'Other'
];

const otherItems = [
  'Emergency lighting', 'Alarms', 'Toilet', 'Roof',
  'Stairwells - Clear', 'Landings - Clear', 'Plug socket(s)'
];

const healthSafetyItems = [
  'Unused water outlets run for 2 minutes', 'Obstacles',
  'Electric voltage over 13 amps', 'Other'
];

const StandardMonthlyInspectionPDF = ({ data }) => {
  if (!data) return null;

  const getMonthName = (monthNumber) => {
    const month = parseInt(monthNumber);
    return monthNames[month - 1] || 'Unknown';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    if (dateString.includes('/')) return dateString;
    try {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
    } catch (e) {
      console.error('Date parsing error:', e);
    }
    return dateString;
  };

  // Get item status from checklist data
  const getItemStatus = (section, itemName, locationName = null) => {
    let sectionData;

    // Handle nested location data structure: location["Communal area - Location"]["Door"]
    if (locationName && data.location) {
      sectionData = data.location[locationName];
    } else if (!data[section] || typeof data[section] !== 'object') {
      return { isGood: true, notes: '' };
    } else {
      sectionData = data[section];
    }

    if (!sectionData || typeof sectionData !== 'object') {
      return { isGood: true, notes: '' };
    }

    // Try multiple key formats to match backend data
    const normalizedItem = itemName.toLowerCase().replace(/[^a-z0-9]/g, '_');
    const snakeCaseItem = itemName.toLowerCase().replace(/\s+/g, '_').replace(/[()\/]/g, '');
    const camelCaseItem = itemName.toLowerCase().replace(/\s+(.)/g, (_, c) => c.toUpperCase()).replace(/[()\/]/g, '');

    // Try to find the item with various key formats
    const item = sectionData[normalizedItem] ||
                 sectionData[snakeCaseItem] ||
                 sectionData[camelCaseItem] ||
                 sectionData[itemName] ||
                 sectionData[itemName.toLowerCase()];

    if (item && typeof item === 'object') {
      // Check condition field: '1' = Good, '0' = Not Good
      const isGood = item.condition === '1' ||
                     item.condition === 1 ||
                     item.condition === undefined ||
                     item.condition === '' ||
                     item.status === 'good' ||
                     item.status === true ||
                     item.value === 'good' ||
                     (item.status !== 'requires_attention' &&
                      item.status !== 'bad' &&
                      item.status !== 'not_good' &&
                      item.status !== false &&
                      item.condition !== '0' &&
                      item.condition !== 0);
      return {
        isGood,
        notes: item.notes || item.comment || ''
      };
    }
    // If item is a boolean
    if (typeof item === 'boolean') {
      return { isGood: item, notes: '' };
    }
    return { isGood: true, notes: '' };
  };

  // Get all location names from data
  const getLocationNames = () => {
    if (!data.location || typeof data.location !== 'object') {
      return ['Communal area - Location'];
    }
    const locationKeys = Object.keys(data.location);
    const defaultLocation = 'Communal area - Location';

    if (locationKeys.length === 0) {
      return [defaultLocation];
    }

    // Ensure default location is first
    if (!locationKeys.includes(defaultLocation)) {
      return [defaultLocation, ...locationKeys];
    }
    const otherLocations = locationKeys.filter(loc => loc !== defaultLocation);
    return [defaultLocation, ...otherLocations];
  };

  const locationNames = getLocationNames();

  // Meter readings.
  //
  // Oct 2026 onwards: rows come from the property's meter register, already
  // joined to type / serial / location by the API. Sep 2026 and earlier: the
  // legacy [name, reading, serial] triples in reading_fields.
  const useNewMeterRegister = usesNewMeters(data);

  const getMeterReadings = () => {
    if (useNewMeterRegister) {
      const rows = Array.isArray(data.meter_readings)
        ? data.meter_readings
        : [];
      return rows.map((row) => ({
        // There is no meter name any more -- the TYPE is the label.
        name: row.meter_type || 'Meter',
        reading: row.reading || '',
        serial: row.serial_number || '',
        location: row.location || '',
      }));
    }

    const readings = [];
    if (data.reading_fields && Array.isArray(data.reading_fields)) {
      data.reading_fields.forEach((reading, index) => {
        const name = data.reading_fields_names?.[index] || `Meter ${index + 1}`;
        const serial = data.reading_fields_serials?.[index] || '';
        readings.push({ name, reading, serial, location: '' });
      });
    }
    return readings;
  };

  const meterReadings = getMeterReadings();
  const gasReading = meterReadings.find(r => r.name.toLowerCase().includes('gas')) || meterReadings[0];
  const electricityReading = meterReadings.find(r => r.name.toLowerCase().includes('electric')) || meterReadings[1];

  // Meter photos: the standard four (image_5..image_8) are always shown; extra
  // slots (image_9..image_14) appear only when they contain an image. Labels
  // come from each slot's name field, falling back to the standard defaults.
  const METER_PHOTO_DEFAULT_LABELS = {
    image_5: 'Gas Meter 1',
    image_6: 'Gas Meter 2',
    image_7: 'Electric Meter',
    image_8: 'Water Meter',
  };
  // Meter photos.
  //
  // Oct 2026 onwards: one photo per registered meter, captioned TYPE + SERIAL
  // so two meters of the same type stay distinguishable -- the caption stands
  // alone under the image with nothing else to tell them apart.
  const newMeterPhotos = useNewMeterRegister
    ? (Array.isArray(data.meter_readings) ? data.meter_readings : []).map(
        (row) => ({
          field: 'meter_photo_' + row.property_meter_id,
          url: row.photo_url,
          label: [row.meter_type, row.serial_number]
            .filter(Boolean)
            .join(' \u2014 ')
            .toUpperCase() || 'METER',
        })
      )
    : [];
  const legacyMeterPhotos = [
    'image_5', 'image_6', 'image_7', 'image_8', 'image_9',
    'image_10', 'image_11', 'image_12', 'image_13', 'image_14',
  ]
    .map((field, idx) => ({
      field,
      url: data[`${field}_url`],
      label: (
        data[`${field}_name`] ||
        METER_PHOTO_DEFAULT_LABELS[field] ||
        'Meter'
      ).toUpperCase(),
      isStandard: idx < 4,
    }))
    .filter((photo) => photo.isStandard || photo.url);

  const meterPhotos = useNewMeterRegister
    ? newMeterPhotos
    : legacyMeterPhotos;

  // Render checklist table - locationName is optional for location sections
  const renderChecklistTable = (items, sectionKey, locationName = null) => (
    <View style={styles.checklistTable}>
      <View style={styles.checklistHeader}>
        <Text style={styles.checklistHeaderName}>Item Name</Text>
        <View style={[styles.checklistHeaderCondition, { flexDirection: 'column' }]}>
          <Text style={{ textAlign: 'center', marginBottom: 3 }}>Condition</Text>
          <View style={styles.conditionSubHeader}>
            <Text style={styles.conditionGood}>Good</Text>
            <Text style={styles.conditionNotGood}>Not Good</Text>
          </View>
        </View>
        <Text style={styles.checklistHeaderNotes}>Notes</Text>
      </View>
      {items.map((item, index) => {
        const status = getItemStatus(sectionKey, item, locationName);
        const isLast = index === items.length - 1;
        return (
          <View key={index} style={isLast ? styles.checklistRowLast : styles.checklistRow}>
            <Text style={styles.checklistName}>{item}</Text>
            <View style={styles.checklistConditionCell}>
              <View style={styles.checklistGood}>
                {status.isGood ? (
                  <Svg width="12" height="12" viewBox="0 0 24 24">
                    <Path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#000" />
                  </Svg>
                ) : null}
              </View>
              <View style={styles.checklistNotGood}>
                {!status.isGood ? (
                  <Svg width="12" height="12" viewBox="0 0 24 24">
                    <Path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="#000" />
                  </Svg>
                ) : null}
              </View>
            </View>
            <Text style={styles.checklistNotes}>{status.notes}</Text>
          </View>
        );
      })}
    </View>
  );

  return (
    <Document>
      {/* Page 1: Cover Page */}
      <Page size="A4" style={styles.coverPage}>
        <View style={styles.coverPageInnerView}>
          <Image
            src="/assets/images/reports/building_first_page.jpg"
            style={styles.coverBackground}
          />
          <Image
            src="/assets/images/GG_Logo_RGB_800.png"
            style={styles.coverLogo}
          />
          <View style={styles.coverTitleBox}>
            <Text style={styles.coverTitle}>
              ENSURE YOUR{'\n'}PROPERTY IS SAFE{'\n'}WITH PROPERTY{'\n'}GUARDIANS
            </Text>
          </View>
          <View style={styles.coverFooter}>
            <Text style={styles.coverFooterWebsite}>www.global-guardians.co.uk</Text>
            <Text style={styles.coverFooterPhone}>0800 368 9601</Text>
          </View>
        </View>
      </Page>

      {/* Page 2: Introducing Global Guardians */}
      <Page size="A4" style={styles.contentPage}>
        <Text style={styles.introTitle}>Introducing{'\n'}Global Guardians</Text>
        <Text style={styles.introSubtitle}>
          The most cost effective way to secure your vacant property from unauthorised entry, vandalism & squatters
        </Text>
        <Text style={styles.introText}>
          We are an innovative property guardian company with a wealth of experience in the property industry.
        </Text>

        <View style={styles.twoColumnRow}>
          <View style={styles.serviceBox}>
            <View style={styles.serviceBoxHeader}>
              <Text style={styles.serviceBoxHeaderText}>Our core services.</Text>
            </View>
            <View style={styles.serviceBoxBody}>
              {['Property guardians', 'Regeneration specialists', 'Property renovation to habitable status', 'VOA empty building rates specialist'].map((item, i) => (
                <View key={i} style={styles.checkItem}>
                  <View style={styles.checkBox}>
                    <Svg width="10" height="10" viewBox="0 0 24 24">
                      <Path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#fff" />
                    </Svg>
                  </View>
                  <Text style={styles.checkText}>{item}</Text>
                </View>
              ))}
            </View>
          </View>
          <View style={styles.serviceBoxLast}>
            <View style={styles.serviceBoxHeader}>
              <Text style={styles.serviceBoxHeaderText}>Financial achievements.</Text>
            </View>
            <View style={styles.serviceBoxBody}>
              {['Saved clients 12.2m in security costs', 'Managing 4.1 bn of assets', '1.2m empty business rates saved'].map((item, i) => (
                <View key={i} style={styles.checkItem}>
                  <View style={styles.checkBox}>
                    <Svg width="10" height="10" viewBox="0 0 24 24">
                      <Path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#fff" />
                    </Svg>
                  </View>
                  <Text style={styles.checkText}>{item}</Text>
                </View>
              ))}
            </View>
          </View>
        </View>

        <View style={styles.twoColumnRow}>
          <View style={styles.advantagesBox}>
            <Text style={styles.advantagesTitle}>
              The advantages of property guardians over the conventional void property security methods
            </Text>
            {['Eliminate vandalism & criminal damage', 'Prevent squatters & illegal occupation', 'Reduce risk of fire', 'Prevent theft', 'Avoid burst pipes', 'Deter rodents & pests', 'Reduces anti-social behaviour', 'Enhances the local community', 'Helps local businesses'].map((item, i) => (
              <View key={i} style={styles.advantagesItem}>
                <View style={styles.advantagesCheckBox}>
                  <Svg width="10" height="10" viewBox="0 0 24 24">
                    <Path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#0a7280" />
                  </Svg>
                </View>
                <Text style={styles.advantagesText}>{item}</Text>
              </View>
            ))}
          </View>
          <View style={styles.quoteBox}>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>Our fully trained</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>staff ensure exactly</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>the right property</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>guardians to secure</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>your building.</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>This ensures you</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>have the safest</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>and most cost</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>effective vacant</Text></View>
            <View style={styles.quoteLine}><Text style={styles.quoteText}>property protection.</Text></View>
          </View>
        </View>
      </Page>

      {/* Page 3: Services */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.servicesHeader}>
          <Text style={styles.servicesTitle}>helping you{'\n'}protect your property</Text>
        </View>
        <Text style={styles.servicesSubtitle}>Our services include</Text>
        <View style={styles.servicesGrid}>
          {[
            { title: 'High End House Sitters', text: 'Global Guardians Management Ltd protects high end properties for property owners at a fraction of the cost in comparison to concierge security officers.', icon: '/images/services/high_end_house_sitters.png' },
            { title: 'Safety Management', text: 'In order to safely protect vacant property we follow a comprehensive Safety Management Plan taking into account the safety of our property guardians.', icon: '/images/services/safety_management.png' },
            { title: 'Building Management', text: 'For every building Global Guardians protects, a full management service is provided. Our property management service is designed to meet the requirements of any property.', icon: '/images/services/building_management.png' },
            { title: 'Improve Your Void', text: 'Global Guardians have created a unique long term property protection service designed to rejuvenate derelict buildings. We call this our "Improve your Void" service.', icon: '/images/services/improve_your_voids.png' },
            { title: 'Life Enhancing Chances', text: 'Global Guardians look to add social and environmental value to an area through our Guardian Solution.', icon: '/images/services/life_enhancing_chances.png' },
            { title: 'Property Guardian Insurance', text: 'Global Guardians can help you lower your empty building insurance costs through our unique guardianship scheme.', icon: '/images/services/property_guardian_insurance.png' },
            { title: 'Empty Business Rate Reduction', text: 'By utilising our property guardian solution, owners of vacant property are able to make substantial savings on empty building rates.', icon: '/images/services/empty_building_rates_reduction.png' },
            { title: 'Void into profit', text: 'For our long term clients we offer guaranteed revenue streams on specific buildings to ensure you recoup income from your vacant properties.', icon: '/images/services/voids_into_profit.png' },
            { title: 'Property Guardian solutions', text: 'Innovative property guardianship solutions to fully secure your property.', icon: '/images/services/property_guardian_solution.png' },
          ].map((service, i) => (
            <View key={i} style={i % 2 === 0 ? styles.serviceCard : styles.serviceCardOdd}>
              <View style={styles.serviceIcon}>
                <Image src={service.icon} style={styles.serviceIconImage} />
              </View>
              <View style={styles.serviceCardContent}>
                <Text style={styles.serviceCardTitle}>{service.title}</Text>
                <Text style={styles.serviceCardText}>{service.text}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>

      {/* Page 4: Monthly Inspection Report */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>
        <Text style={styles.reportTitle}>
          Monthly Inspection Report For The Month Of {getMonthName(data.month)} {data.year}
        </Text>

        {/* Photo Grid */}
        <View style={styles.photoGrid}>
          <View style={styles.photoBox}>
            {data.image_1_url ? (
              <Image src={data.image_1_url} style={styles.photoImage} />
            ) : (
              <View style={styles.noPhotoBox}><Text style={styles.noPhotoText}>No photo</Text></View>
            )}
            <View style={styles.photoLabel}><Text style={styles.photoLabelText}>FRONT</Text></View>
          </View>
          <View style={styles.photoBoxRight}>
            {data.image_2_url ? (
              <Image src={data.image_2_url} style={styles.photoImage} />
            ) : (
              <View style={styles.noPhotoBox}><Text style={styles.noPhotoText}>No photo</Text></View>
            )}
            <View style={styles.photoLabel}><Text style={styles.photoLabelText}>LIVING SPACE</Text></View>
          </View>
          <View style={styles.photoBox}>
            {data.image_3_url ? (
              <Image src={data.image_3_url} style={styles.photoImage} />
            ) : (
              <View style={styles.noPhotoBox}><Text style={styles.noPhotoText}>No photo</Text></View>
            )}
            <View style={styles.photoLabel}><Text style={styles.photoLabelText}>KITCHEN/BATHROOM</Text></View>
          </View>
          <View style={styles.photoBoxRight}>
            {data.image_4_url ? (
              <Image src={data.image_4_url} style={styles.photoImage} />
            ) : (
              <View style={styles.noPhotoBox}><Text style={styles.noPhotoText}>No photo</Text></View>
            )}
            <View style={styles.photoLabel}><Text style={styles.photoLabelText}>COMMUNAL AREA</Text></View>
          </View>
        </View>

        {/* Property Info */}
        <View style={styles.infoTable}>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Property Address:</Text>
            <Text style={styles.infoValue}>
              {data.address_1 || ''}{data.address_2 ? `, ${data.address_2}` : ''}{data.town ? `, ${data.town}` : ''}{data.postcode ? `, ${data.postcode}` : ''}
            </Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Client Contact:</Text>
            <Text style={styles.infoValue}>{data.client_contact || 'N/A'}</Text>
          </View>
          <View style={styles.infoRowLast}>
            <Text style={styles.infoLabel}>Company:</Text>
            <Text style={styles.infoValue}>{data.client || 'N/A'}</Text>
          </View>
        </View>

        <View style={styles.infoTableTwoCol}>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabelSmall}>Key Number:</Text>
            <Text style={styles.infoValueSmall}>{data.key_number || data.property_id_name || 'N/A'}</Text>
            <Text style={styles.infoLabelSmall}>Inspection Date:</Text>
            <Text style={styles.infoValueSmallLast}>{formatDate(data.inspection_date)}</Text>
          </View>
          <View style={styles.infoRowLast}>
            <Text style={styles.infoLabelSmall}>Number of Guardians:</Text>
            <Text style={styles.infoValueSmall}>{data.guardians_number || 'N/A'}</Text>
            <Text style={styles.infoLabelSmall}>Head Guardian:</Text>
            <Text style={styles.infoValueSmallLast}>{data.head_guardian || ''}</Text>
          </View>
        </View>

        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>

      {/* Page 5: Meter Readings */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>

        <View style={styles.meterTable}>
          {meterReadings.map((meter, index) => (
            <View key={index} style={index === meterReadings.length - 1 ? styles.meterRowLast : styles.meterRow}>
              <Text style={styles.meterLabel}>
                Meter Readings{'\n'}(
                {meter.name.toLowerCase().replace('reading ', '')}
                {meter.location ? ' \u2014 ' + meter.location : ''}):
              </Text>
              <Text style={styles.meterValue}>{meter.reading || 'N/A'}</Text>
              <Text style={styles.meterSerialLabel}>Serial Number:</Text>
              <Text style={styles.meterSerialValue}>{meter.serial || 'N/A'}</Text>
            </View>
          ))}
        </View>

        {/* Meter Photo Grid */}
        <View style={styles.photoGrid}>
          {meterPhotos.map((photo, index) => (
            <View
              key={photo.field}
              style={index % 2 === 0 ? styles.photoBox : styles.photoBoxRight}
            >
              {photo.url ? (
                <Image src={photo.url} style={styles.photoImage} />
              ) : (
                <View style={styles.noPhotoBox}><Text style={styles.noPhotoText}>No photo</Text></View>
              )}
              <View style={styles.photoLabel}><Text style={styles.photoLabelText}>{photo.label}</Text></View>
            </View>
          ))}
        </View>

        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>

      {/* Page 6: Checklist - External & First Communal Location */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>
        <Text style={styles.checklistTitle}>Monthly Inspection Checklist</Text>
        <Text style={styles.checklistSection}>External</Text>
        {renderChecklistTable(externalItems, 'external')}
        {locationNames.length > 0 && (
          <>
            <Text style={styles.checklistSection}>{locationNames[0]}</Text>
            {renderChecklistTable(communalItems, 'location', locationNames[0])}
          </>
        )}
        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>

      {/* Additional Communal Area Pages - one page per additional location */}
      {locationNames.slice(1).map((locationName, index) => (
        <Page key={`location-${index}`} size="A4" style={styles.contentPage}>
          <View style={styles.logoContainer}>
            <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
          </View>
          <Text style={styles.checklistSection}>{locationName}</Text>
          {renderChecklistTable(communalItems, 'location', locationName)}
          <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
        </Page>
      ))}

      {/* Page 7: Checklist - Kitchen */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>
        <Text style={styles.checklistSection}>Kitchen</Text>
        {renderChecklistTable(kitchenItems, 'kitchen')}
        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>

      {/* Page 8: Checklist - Living space */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>
        <Text style={styles.checklistSection}>Living space</Text>
        {renderChecklistTable(livingSpaceItems, 'living_space')}
        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>

      {/* Page 9: Checklist - Bathroom & Other */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>
        <Text style={styles.checklistSection}>Bathroom</Text>
        {renderChecklistTable(bathroomItems, 'bathroom')}
        <Text style={styles.checklistSection}>Other</Text>
        {renderChecklistTable(otherItems, 'other')}
        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>

      {/* Page 10: Checklist - Health and Safety & Conclusion */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>
        <Text style={styles.checklistSection}>Health and Safety</Text>
        {renderChecklistTable(healthSafetyItems, 'health_and_safety')}

        <Text style={styles.ticketNote}>
          A ticket will be raised and carried out for any issues stated above on My-Globe.
        </Text>

        <Text style={styles.conclusionTitle}>Conclusion</Text>
        <Text style={styles.conclusionText}>
          I trust that this inspection report is satisfactory.
        </Text>
        <Text style={styles.conclusionText}>
          If you have any questions, requests or if you would like Global Guardians to provide you with a no obligation free-of-charge quote for any other vacant properties you manage please do not hesitate to contact me and I would be delighted to assist you.
        </Text>
        <Text style={styles.signOff}>Yours sincerely,</Text>

        {data.e_sign && (
          <Image src={data.e_sign} style={styles.signatureImage} />
        )}

        <Text style={styles.inspectorName}>
          Property Inspector: {data.account_manager || 'Client Care Team'}
        </Text>

        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>

      {/* Page 11: Empty page with logo */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>
        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>

      {/* Page 12: Footer/Contact Page */}
      <Page size="A4" style={styles.contentPage}>
        <View style={styles.logoContainer}>
          <Image src="/assets/images/GG_Logo_RGB_800.png" style={styles.pageLogo} />
        </View>
        <View style={styles.footerContent}>
          <Text style={styles.footerCompanyName}>Global Guardians</Text>
          <Text style={styles.footerAddress}>Evolution House</Text>
          <Text style={styles.footerAddress}>Iceni Court</Text>
          <Text style={styles.footerAddress}>Delft Way</Text>
          <Text style={styles.footerAddress}>Norwich</Text>
          <Text style={styles.footerAddress}>Norfolk</Text>
          <Text style={styles.footerAddress}>NR6 6BB</Text>
          <Text style={styles.footerAddress}>UK</Text>

          <Text style={styles.footerEmail}>
            <Text style={styles.footerEmailLabel}>e: </Text>
            enquiries@global-guardians.co.uk
          </Text>
          <Text style={styles.footerWebsite}>www.Global-Guardians.co.uk</Text>

          <View style={styles.footerLogosContainer}>
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-1.png" style={styles.footerLogoItem} />
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-2.png" style={styles.footerLogoItem} />
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-3.png" style={styles.footerLogoItem} />
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-4.png" style={styles.footerLogoItem} />
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-5.png" style={styles.footerLogoItem} />
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-6.png" style={styles.footerLogoItem} />
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-7.png" style={styles.footerLogoItem} />
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-8.png" style={styles.footerLogoItem} />
            <Image src="/assets/images/mtvh-pp-logos-pdf/mtvh-pp-logo-pdf-9.png" style={styles.footerLogoItem} />
          </View>
        </View>
        <Text style={styles.pageFooter}>www.global-guardians.co.uk</Text>
      </Page>
    </Document>
  );
};

export default StandardMonthlyInspectionPDF;
